/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React from 'react'
import { getImageUrl } from '../utils/dynamicMedia'

/**
 * EGGS SmartPicture Component
 * Renders an AEM image with SmartCrop support via <picture> element.
 *
 * @param {Object} props
 * @param {Object} props.image - AEM image reference object (_dmS7Url, _publishUrl, _dynamicUrl)
 * @param {string[]} [props.smartCrops] - Available SmartCrop names from provider
 * @param {string} [props.preferredCrop] - Single crop for fixed-size usage (e.g. 'Small' for avatars)
 * @param {string} [props.fallback] - Fallback image URL when no AEM image available
 * @param {string} props.alt - Alt text
 * @param {string} [props.className] - CSS classes for the <img> element
 */
export default function SmartPicture({
  image,
  smartCrops,
  preferredCrop,
  fallback,
  alt = '',
  className = '',
}) {
  const resolved = getImageUrl(image, smartCrops, preferredCrop)

  if (!resolved && !fallback) return null

  if (!resolved) {
    return <img src={fallback} alt={alt} className={className} />
  }

  if (resolved.sources?.length) {
    return (
      <picture>
        {resolved.sources.map((s) => (
          <source key={s.media} media={s.media} srcSet={s.srcSet} />
        ))}
        <img src={resolved.src} alt={alt} className={className} />
      </picture>
    )
  }

  return <img src={resolved.src} alt={alt} className={className} />
}
